// Peta jangkauan CV GRCom: HQ Medan + cabang, garis cabang & titik live berkedip.
import { useLang } from "@/lib/i18n";

const HQ = { x: 12.7, y: 33.5, label: "Medan", region: "Sumatera Utara · HQ" };
const LABEL_POS = {
  bottom: "left-1/2 -translate-x-1/2 top-3.5", top: "left-1/2 -translate-x-1/2 bottom-3.5",
  left: "right-3 top-1/2 -translate-y-1/2", right: "left-3 top-1/2 -translate-y-1/2",
};
const BRANCHES = [
  { x: 18.6, y: 45.8, label: "Palembang", region: "Sumatera Selatan" },
  { x: 27.3, y: 57.5, label: "Bandar Lampung", lp: "left", region: "Lampung" },
  { x: 67.6, y: 35.2, label: "Manado", lp: "top", region: "Sulawesi Utara" },
  { x: 42.3, y: 41.9, label: "Pontianak", region: "Kalimantan Barat" },
  { x: 49.5, y: 47, label: "Balikpapan", region: "Kalimantan Timur" },
  { x: 54.6, y: 48.3, label: "Kolaka", lp: "top", region: "Sulawesi Tenggara" },
  { x: 63.9, y: 38.7, label: "Gorontalo", lp: "left", region: "Sulawesi" },
  { x: 90.8, y: 54.2, label: "Jayapura", region: "Papua" },
  { x: 56.6, y: 49, label: "Konawe", lp: "right", region: "Sulawesi Tenggara" },
  { x: 72.5, y: 37.5, label: "Ternate", lp: "right", region: "Maluku Utara" },
  { x: 50.5, y: 70.5, label: "Denpasar", region: "Bali" },
  { x: 28.2, y: 61.0, label: "Bogor", lp: "top", region: "Jawa Barat" },
  { x: 29.7, y: 62.3, label: "Bandung", region: "Jawa Barat" },
  { x: 39.2, y: 65.2, label: "Solo", region: "Jawa Tengah" },
  { x: 45.5, y: 67.6, label: "Surabaya", region: "Jawa Timur" },
];

const SEAS = [
  { x: 22, y: 82, label: "Samudra Hindia", big: true },
  { x: 82, y: 14, label: "Samudra Pasifik", big: true },
  { x: 33, y: 20, label: "Laut Cina Selatan" },
  { x: 36, y: 58.5, label: "Laut Jawa" },
  { x: 55, y: 30.5, label: "Laut Sulawesi" },
  { x: 66, y: 60, label: "Laut Banda" },
  { x: 47, y: 77, label: "Laut Flores" },
  { x: 82, y: 70, label: "Laut Arafura" },
];

export function IndonesiaMap({ showLabels = true }) {
  const { t } = useLang();
  return (
    <div className="relative w-full" data-testid="indonesia-map">
      <img src="/indonesia-map-sea.png" alt="Peta jangkauan CV GRCom di Indonesia" className="w-full h-auto block select-none" draggable="false" />

      {SEAS.map((s) => (
        <span key={s.label} className={`absolute pointer-events-none select-none italic tracking-[0.12em] text-[#2C5F8A]/70 whitespace-nowrap ${s.big ? "text-[9px] sm:text-[11px] font-semibold" : "text-[7px] sm:text-[8px] hidden sm:inline"}`}
          style={{ left: `${s.x}%`, top: `${s.y}%`, transform: "translate(-50%,-50%)" }} data-testid="map-sea-label">
          {t(s.label)}
        </span>
      ))}

      {/* Garis cabang dari HQ ke tiap titik */}
      <svg className="absolute inset-0 w-full h-full pointer-events-none" viewBox="0 0 100 100" preserveAspectRatio="none">
        {BRANCHES.map((b, i) => {
          const mx = (HQ.x + b.x) / 2;
          const my = Math.min(HQ.y, b.y) - 8;
          return (
            <path key={i} d={`M ${HQ.x} ${HQ.y} Q ${mx} ${my} ${b.x} ${b.y}`}
              fill="none" stroke="#22C55E" strokeWidth="1" strokeOpacity="0.9"
              className="map-line" vectorEffect="non-scaling-stroke"
              style={{ animationDelay: `${i * 0.15}s` }} />
          );
        })}
      </svg>

      {/* Titik live */}
      {[{ ...HQ, hq: true }, ...BRANCHES].map((p, i) => (
        <span key={i} className="absolute group" style={{ left: `${p.x}%`, top: `${p.y}%`, transform: "translate(-50%,-50%)", zIndex: p.hq ? 20 : 10 }}>
          <span className="absolute inline-flex rounded-full bg-[#FACC15]/60 map-ring"
            style={{ width: p.hq ? 16 : 10, height: p.hq ? 16 : 10, left: "50%", top: "50%", transform: "translate(-50%,-50%)", animationDelay: `${i * 0.25}s` }} />
          <span className={`relative inline-block rounded-full map-light ${p.hq ? "bg-[#E0A800] ring-2 ring-white shadow-[0_0_10px_2px_rgba(250,204,21,0.8)]" : "bg-[#F5C518] ring-1 ring-[#8A5A0B]/40"}`}
            style={{ width: p.hq ? 12 : 7, height: p.hq ? 12 : 7, animationDelay: `${i * 0.25}s` }} />
          {showLabels && (
            <span className={`absolute ${LABEL_POS[p.lp || "bottom"]} whitespace-nowrap font-semibold px-1.5 py-0.5 rounded-sm shadow-sm transition-opacity ${
              p.hq ? "text-[#166534] bg-white/95 text-[9px]" : "text-foreground bg-white/90 text-[8px] hidden sm:inline-block"
            }`}>
              {p.label}{p.hq ? " · HQ" : ""}
            </span>
          )}
        </span>
      ))}
    </div>
  );
}
